var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 20,
    viewBox: "0 0 33 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_764_15991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8345 2.13889H12.0845V17.8611H20.8345V2.13889Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6399 10C12.6399 6.80555 14.1399 3.97222 16.4455 2.13889C14.751 0.805559 12.6121 0 10.2788 0C4.75103 0 0.278809 4.47222 0.278809 10C0.278809 15.5278 4.75103 20 10.2788 20C12.6121 20 14.751 19.1944 16.4455 17.8611C14.1399 16.0556 12.6399 13.1944 12.6399 10Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6398 10C32.6398 15.5278 28.1676 20 22.6398 20C20.3065 20 18.1676 19.1944 16.4731 17.8611C18.8065 16.0278 20.2787 13.1944 20.2787 10C20.2787 6.80555 18.7787 3.97222 16.4731 2.13889C18.1676 0.805559 20.3065 0 22.6398 0C28.1676 0 32.6398 4.5 32.6398 10Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_764_15991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.3611,
    height: 20,
    fill: "white",
    transform: "translate(0.278809)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default ForwardRef;